<po-page-default
  p-title="Carga Inicial - Importação de Dados"
  p-subtitle="Importe planilhas para realizar a carga inicial de dados."
  [p-breadcrumb]="breadcrumb">

  <div class="page-summary">
    <div class="page-summary-icon">
      <i class="an an-database"></i>
    </div>
    <div class="page-summary-text">
      <p class="po-font-subtitle po-mb-0">Importação de dados para a base do sistema</p>
      <p class="page-summary-hint">Selecione arquivos <b>.xlsx</b> ou <b>.csv</b> seguindo as orientações abaixo. Múltiplos arquivos podem ser enviados simultaneamente.</p>
    </div>
  </div>

  <po-divider></po-divider>

  <!-- Seção: Orientações -->
  <div class="ci-section po-mt-3">
    <div class="ci-section-header">
      <i class="an an-info"></i>
      <span>Orientações</span>
    </div>
    <div class="ci-section-body">
      <p class="po-font-text-large-bold po-mb-2">
        O arquivo deve estar no formato <strong>XLSX</strong> ou <strong>CSV</strong> e seguir as regras:
      </p>
      <div class="ci-rules">
        <div class="ci-rule">
          <i class="an an-check-circle"></i>
          <span>Conter as colunas obrigatórias para cada tipo de movimentação.</span>
        </div>
        <div class="ci-rule">
          <i class="an an-check-circle"></i>
          <span>As colunas devem estar na ordem correta, conforme a documentação.</span>
        </div>
        <div class="ci-rule">
          <i class="an an-check-circle"></i>
          <span>Dados formatados corretamente, sem erros de digitação.</span>
        </div>
        <div class="ci-rule">
          <i class="an an-check-circle"></i>
          <span>Nome do arquivo deve conter o código da tabela, com ou sem colchetes: <b>[JC83XX]</b> ou <b>JC83XX</b>.</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Seção: Códigos disponíveis -->
  <div class="ci-section po-mt-3">
    <div class="ci-section-header">
      <i class="an an-list-bullets"></i>
      <span>Cargas Disponíveis</span>
    </div>
    <div class="ci-section-body">
      <p class="po-font-text po-mb-2">Após a importação, verifique se os dados foram inseridos corretamente.</p>
      <div class="ci-codes-grid">
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8301</span>
          <span class="ci-code-label">Produtos</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8302</span>
          <span class="ci-code-label">Participantes</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8303</span>
          <span class="ci-code-label">CFOP</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8310</span>
          <span class="ci-code-label">Enquadramento Legal</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8312</span>
          <span class="ci-code-label">Códigos Internos</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8313</span>
          <span class="ci-code-label">CFOP Devolução</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge mascara">MASCARA</span>
          <span class="ci-code-label">Máscara de Importação</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Seção: Upload -->
  <div class="ci-section po-mt-3 po-mb-4">
    <div class="ci-section-header">
      <i class="an an-upload-simple"></i>
      <span>Enviar Arquivos</span>
    </div>
    <div class="ci-section-body">
      <app-component-importacao [rotas]="rotas"/>
    </div>
  </div>

</po-page-default>
